import { QALog } from 'types/QALog';
import * as yup from 'yup';

export const initialValues = {
  employee: '',
  date: '',
  hours: '',
  items: [],
  notes: '',
};

export const getInitialValues = (qALog: QALog | null) => ({
  employee: qALog?.employee?._id || '',
  date: qALog?.date || '',
  hours: qALog?.hours || '',
  items: qALog?.items || '',
  notes: qALog?.notes || '',
});

export const validationSchema = yup.object().shape({
  employee: yup.string().required('Employee is required'),
  hours: yup
    .number()
    .typeError('Worked Hours must be a number')
    .required('Worked Hours is required'),
  items: yup
    .array()
    .of(
      yup.object().shape({
        sku: yup.string().required('SKU is required'),
        passed: yup
          .number()
          .typeError('Passed value must be a number')
          .required('Passed value is required'),
        dirty: yup
          .number()
          .typeError('Dirty value must be a number')
          .required('Dirty value is required'),
        damaged: yup
          .number()
          .typeError('Damaged value must be a number')
          .required('Damaged value is required'),
      }),
    )
    .required('Items are required')
    .min(1, 'At least one item must be selected'),
  notes: yup.string(),
});
